type ImportRow = Record<string, unknown>;

type ImportRoom = {
  id: string;
  name: string;
  floor: string;
};

function omitUndefinedValues(row: ImportRow): ImportRow {
  return Object.fromEntries(
    Object.entries(row).filter(([, value]) => typeof value !== 'undefined'),
  );
}

export function getImportsSortedByRoom(
  rows: ImportRow[] | undefined,
  rooms: ImportRoom[],
): Record<string, ImportRow[]> {
  return (rows ?? []).reduce<Record<string, ImportRow[]>>((imports, row) => {
    const room = rooms.find(
      (candidate) =>
        String(candidate.name).trim() === String(row['Room Name']).trim() &&
        String(candidate.floor).trim() === String(row.Floor).trim(),
    );

    if (!room) {
      return imports;
    }

    imports[room.id] ??= [];
    imports[room.id].push(omitUndefinedValues(row));
    return imports;
  }, {});
}
